export const environment = {
  production: true,
  masterApiURL: "https://stage-master-backend.epravaha.com/",
  ApiURL: "https://nhrdf-backend.supplyvalid.com/api/",
    ApiURLW: 'https://stage-backend-2025.epravaha.com/',
};
